module.exports = __webpack_public_path__ + "img/servicenow.5196effd.svg";